<template>

  <div>
    <v-toolbar absolute fixed clipped-left height="50px">
      <v-toolbar-title><router-link to="/home"><img style="max-width: 150px; margin-top:5px" src="@/assets/logoStructube.png"></router-link></v-toolbar-title>

      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn flat disabled class="hidden-sm-and-down">
          {{email}}
        </v-btn>
        <v-btn to="/home" flat class="hidden-sm-and-down">
          home
        </v-btn>
        <v-btn flat @click="logout">
          logout
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <div style="margin-top: 64px">
      <v-layout row wrap style="margin:0 auto; max-width: 1600px">

        <v-flex order-md2 align-center fill-height class="text-xs-left px-5" xs12 md10 lg10>
          <div style="padding-bottom: 25px"><h1 class="text-xs-left">{{trainingName}}</h1></div>


          <!-- <v-progress-linear class="mt-0 mb-4" v-model="trainingProgress"></v-progress-linear> -->
          <v-btn class="text-xs-left" v-if="currSlide < 0" @click="startTraining">
            Start Training
          </v-btn>

          <v-flex v-if="currSlide >= 0">

            <div v-if="lastSlide">
              <div v-if="trainingPercent >= 85">
                  Congratulations, you have successfully completed the training!
                  Training Score: {{trainingPercent}}%
              </div>
              <div v-else style="font-size: 25px">Sorry, you must score at least 85%. Please retake the training by clicking on 'Try again'. <br>
                Training Score: {{trainingPercent}}%
                <div>

                    <v-btn :to="`/home`">
                      Try again
                    </v-btn>

                </div>
              </div>
            </div>
            <div v-else-if="slides[currSlide].pageType == 'consent'">
              <div style="font-size: 20px; " class="pb-4">{{slides[currSlide].description}}</div>
                <iframe class="pb-2" style="border: none" width="100%" height="400px" src="https://firebasestorage.googleapis.com/v0/b/str-hris.appspot.com/o/documents%2FHV719E%20-%20Harassment%20and%20Violence%20in%20the%20Workplace%20(Modifications%20(003).pdf?alt=media&token=91858b35-380d-430b-81da-fe8ed5bfb413"></iframe>
              <form ref="consentForm">
                <v-radio-group>
                  <div class="pb-2">{{slides[currSlide].question}}</div>

                  <v-radio
                    v-for="(v, n) in slides[currSlide].options"
                    :key="n"
                    name="consent"
                    :label="v"
                    :value="n"
                  ></v-radio>
                  <div v-if="answerMode" class="pa-2" style="color: #43A047">
                    Answer: {{answers[slides[currSlide].id].answerText[q.id]}}
                  </div>
                </v-radio-group>
                <v-btn @click="submitTraining">
                  Submit
                </v-btn>
              </form>
            </div>
            <div v-else>
                <div v-if="slides[currSlide].videoUrl">
                  <video controls disablePictureInPicture controlsList="nodownload" @timeupdate="computeVideoTimerPercent" ref="trainingVideo"  width="100%" height="" autoplay >
                    <source v-bind:src="slides[currSlide].videoUrl" type="video/mp4">

                    Your browser does not support HTML5 video.
                  </video>
                    <v-progress-linear class="mt-0 mb-3" v-model="videoTimerPercent"></v-progress-linear>
                </div>


                <div v-if="slides[currSlide].pageType == 'question'">

                  <form text-left ref="testForm">
                    <input name="testId" :value="slides[currSlide].id" style="display: none"/>
                    <div v-for="q in slides[currSlide].questions" style="text-align: left">


                      <v-radio-group required :disabled="answerMode ? true : false">
                        <div class="pb-2">{{q.qData.question}}</div>
                        <v-radio
                          v-for="(v, n) in q.qData.options"
                          :key="n"
                          :name="q.id"
                          :label="v"
                          :value="n"
                        ></v-radio>
                        <div v-show="answerMode" :ref="`answer-${q.id}`" class="pa-2" style="color: #43A047">
                          Answer: {{answers[slides[currSlide].id].answerText[q.id]}}
                        </div>
                      </v-radio-group>

                    </div>
                    <v-btn v-if="answerMode & (currSlide < slides.length)" @click="nextSlide">
                      Next
                    </v-btn>
                    <v-btn type="submit" v-else @click="submitAnswers(slides[currSlide].id, $event)">
                      Submit
                    </v-btn>
                  </form>

                </div>

                <div v-else>
                  <v-btn @click="nextSlide">
                    Next
                  </v-btn>
                </div>
              </div>
            </v-flex>


        </v-flex>
        <v-flex xs12 md2 lg2 pa-2>
          <v-card v-if="currSlide >= 0" style="border-radius: 5px" elevation="0">
            <v-toolbar
              color="grey lighten-2"
              small
              dense
              flat
            >
            <v-toolbar-title class="subheading">Training Timeline</v-toolbar-title>
            </v-toolbar>

            <v-timeline align-top dense class="ml-3 pb-2">
                <v-timeline-item
                  v-for="(slide, i) in slides"
                  :key="i"
                  right
                  small
                  style="padding: 5px"
                  :color="currSlide == i ? 'blue lighten-1' : (currSlide >= i ? 'green lighten-1' : 'grey')"
                >
                <!-- <template v-slot:icon>
                  <v-avatar>
                    <v-icon v-if="i == currSlide" color="blue lighten-1">timelapse</v-icon>
                    <v-icon v-if="i < currSlide" color="green lighten-1">check_circle</v-icon>
                    <v-icon v-if="i > currSlide" color="grey">check_circle_outline</v-icon>
                  </v-avatar>
                </template> -->
                  <v-layout pt-2>{{slide.title}}</v-layout>
                </v-timeline-item>
              </v-timeline>
              <!-- <v-list dense rounded v-for="(slide, i) in slides">
                <v-list-tile
                  :key="slide.id"
                  avatar
                >
                  <v-list-tile-avatar>
                    <v-icon v-if="i == currSlide" color="blue lighten-1">timelapse</v-icon>
                    <v-icon v-if="i < currSlide" color="green lighten-1">check_circle</v-icon>
                    <v-icon v-if="i > currSlide" color="grey">check_circle_outline</v-icon>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title>{{slide.title}}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list> -->

          </v-card>
        </v-flex>
      </v-layout>

      <v-snackbar
        v-model="snackbar"
        :timeout="10000"
        top
        auto-height
        right
        color="error"
      >
        <div class="text-xs-left">{{ error }}</div>
        <div>
          <v-btn
            dark
            flat
            @click="snackbar = false"
            justify-end
          >
          <v-icon>close</v-icon>
        </v-btn>
      </div>
    </v-snackbar>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage'
import pdf from 'pdfvuer'
import { LOGOUT } from "@/store/actions.type";

export default {
  name: "training",
  components: {
    pdf
  },
  data() {
    return {
      trainingName: null,
      trainingId: null,
      trainingDescription: null,
      trainingPoints: 0,
      trainingTotalPoints: 1,
      slides: [],
      currSlide: -1,
      totalSlides: 1,
      answers: {},
      answerMode: false,
      consent: null,
      lastSlide: false,
      staffId: null,
      staffName: "",
      videoTimerPercent: 0,
      error: "",
      snackbar: false,
    };
  },
  mounted: function(){


    firebase.firestore().collection('training').doc('training1').get()
    .then((doc) =>{
      if (doc.exists) {

          let data = doc.data()
          this.trainingName = data.name;
          this.trainingId = doc.id;
          this.trainingDescription = data.description;
      } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
      }
    }).catch(function(error) {
        console.log("Error getting document:", error);
    });

    firebase.firestore().collection('trainingSections').doc('06is0IaHJHr4AvoguwGH').get().then(doc => {
      console.log(doc);
    })
    firebase.firestore().collection('trainingSections').doc('06is0IaHJHr4AvoguwGH').collection('pages').get()
    .then(querySnapshot => {
        querySnapshot.docs.forEach(doc => {
          let data = doc.data();
          this.totalSlides++;
          this.slides[data.order-1] = doc.data();
          this.slides[data.order-1].id = doc.id;

          if(data.pageType == "question") {
            firebase.firestore().collection('trainingSections').doc('06is0IaHJHr4AvoguwGH').collection('pages').doc(doc.id).collection('questions').get()
            .then(querySnapshot => {
                this.slides[data.order-1].questions = []
                querySnapshot.docs.forEach(qdoc => {
                  let qdata = qdoc.data();

                  if(this.slides[data.order-1].questions) {
                    this.slides[data.order-1].questions[qdata.order-1] = {id: qdoc.id, qData: qdata}
                  }

              });
            }).catch(function(error) {
                console.log("Error getting document:", error);
            });
          }
      });
    }).catch(function(error) {
        console.log("Error getting document:", error);
    });

    firebase.firestore().collection('users').doc(this.userId).get()
    .then((doc) =>{
      if (doc.exists) {

          let data = doc.data()
          this.staffId = data.staffId;
          this.staffName = data.name;

      } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
      }
    }).catch(function(error) {
        console.log("Error getting document:", error);
    });

    firebase.firestore().collection('training').doc('training1').get()
    .then((doc) =>{
      if (doc.exists) {

          let data = doc.data()
          this.trainingName = data.name;
          this.trainingDescription = data.description;

      } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
      }
    }).catch(function(error) {
        console.log("Error getting document:", error);
    });

    /// ANSWERS
    firebase.firestore().collection('trainingAnswers').get()
    .then(querySnapshot => {

        querySnapshot.docs.forEach(adoc => {
          let adata = adoc.data();

          this.answers[adoc.id] = adata;

      });
    }).catch(function(error) {
        console.log("Error getting document:", error);
    });

  },
  methods: {
    logout() {
      this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }))
        .catch(() => this.$data.snackbar = true);
    } ,
    computeVideoTimerPercent() {
      if(this.$refs.trainingVideo) {
        this.videoTimerPercent = this.$refs.trainingVideo.currentTime / this.$refs.trainingVideo.duration * 100;
      }
    },
    nextSlide(){

      if(this.$refs.trainingVideo) {
        if (this.$refs.trainingVideo.currentTime > this.$refs.trainingVideo.duration - 2) {
          this.goNextSlide();
        } else {
          this.error = "The training video must be completed before proceeding ."
          this.snackbar = true
        }
      } else {
        this.goNextSlide();
      }




    },
    goNextSlide() {
      this.snackbar = false;
      this.videoTimerPercent = 0;
      if(this.currSlide + 1  < this.slides.length) {
        this.currSlide = 1 + this.currSlide;
        this.answerMode = false;
      } else {
        this.lastSlide = true
      }
      // console.log(this.$refs.trainingVideo);
    },
    startTraining(){
      this.currSlide = 0
    },
    submitAnswers(pageId, event) {
      event.preventDefault()
      var fd = new FormData(this.$refs.testForm)
      let valid = true;
      for(let qa in this.answers[pageId].answers) {
        if(!fd.get(qa))
        {
          valid = false;
        }
      }

      if(valid){
        for(let qa in this.answers[pageId].answers) {
          this.trainingTotalPoints++;
          if(this.answers[pageId].answers[qa] == fd.get(qa)) {
            this.trainingPoints++;
          } else {
            this.$refs[`answer-${qa}`][0].style.color = '#C62828'
          }

            this.$refs[`answer-${qa}`][0].style.backgroundColor = '#ECEFF1'

        }
        this.answerMode = true;
      } else {
        this.error = "Please answer all questions."
        this.snackbar = true
      }

      //send data back

    },
    submitTraining() {

      var fd = new FormData(this.$refs.consentForm)
      let consent = fd.get("consent");


      if(consent) {
        this.trainingPercent = Math.round(this.trainingPoints/(this.trainingTotalPoints-1) * 100)
        this.consent = consent;

        firebase.firestore().collection('trainingResults').where("staffId", "==", this.staffId).where("trainingId", "==", this.trainingId).get()
        .then((querySnapshot) => {

            let doc = querySnapshot.docs[0]
            if (doc) {

              firebase.firestore().collection('trainingResults').doc(doc.id).set({
                staffId: this.staffId,
                staffName: this.staffName,
                trainingId: this.trainingId,
                points: this.trainingPoints,
                percent: this.trainingPercent,
                consent: this.consent,
                dateCompleted: firebase.firestore.Timestamp.fromDate(new Date())
              })
            } else {

              firebase.firestore().collection('trainingResults').add({
                staffId: this.staffId,
                staffName: this.staffName,
                trainingId: this.trainingId,
                points: this.trainingPoints,
                percent: this.trainingPercent,
                consent: this.consent,
                dateCompleted: firebase.firestore.Timestamp.fromDate(new Date())
              })
            }



        }).catch(function(error) {
            console.log("Error getting document:", error);
        });

        this.currSlide++;
        this.lastSlide = true
      }else {
        this.error = "Please answer all questions."
        this.snackbar = true
      }
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors,
      userId: state => state.auth.user.uid,
      email: state => state.auth.user.email
    }),
    trainingProgress: function() {
      return ((this.currSlide+1)/this.totalSlides) * 100;
    }

  }
};
</script>
